export enum StrongmanEventTypeEnum {
	StoneOff = "Stone Off"
}
